"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureInactive = exports.isFeatureActive = exports.initializeFeatureFlags = void 0;
var LDClient = __importStar(require("launchdarkly-js-client-sdk"));
var logger_1 = require("../logger");
var ldclient;
var initializeFeatureFlags = function (_a) {
    var email = _a.email, credentials = _a.credentials;
    if (!email || !credentials || (credentials && !credentials.clientSideID)) {
        logger_1.logger.error('initializeFeatureFlags', 'email and credentials are required', { email: email, credentials: credentials });
        return;
    }
    logger_1.logger.log("initializeFeatureFlags", "using email ".concat(email, " and clientSideID ").concat(credentials.clientSideID));
    var ldclientRef = LDClient.initialize(credentials.clientSideID, {
        key: email,
        email: email,
    }, {
        bootstrap: 'localStorage',
    });
    ldclientRef.on('ready', function () {
        ldclient = ldclientRef;
    });
};
exports.initializeFeatureFlags = initializeFeatureFlags;
var isFeatureActive = function (_a) {
    var _b = _a === void 0 ? {} : _a, feature = _b.feature, _c = _b.activeValue, activeValue = _c === void 0 ? true : _c, functionName = _b.functionName, _d = _b.defaultValue, defaultValue = _d === void 0 ? false : _d;
    if (!ldclient || !feature) {
        logger_1.logger.log('isFeatureActive', 'client not initialized yet returning default');
        return defaultValue;
    }
    var showFeature = ldclient.variation(feature, defaultValue);
    logger_1.logger.log('isFeatureActive', "checking feature ".concat(feature, " ").concat(functionName ? 'in ' + functionName : ''));
    return showFeature === activeValue;
};
exports.isFeatureActive = isFeatureActive;
var isFeatureInactive = function (_a) {
    var _b = _a === void 0 ? {} : _a, feature = _b.feature, _c = _b.activeValue, activeValue = _c === void 0 ? true : _c, functionName = _b.functionName, _d = _b.defaultValue, defaultValue = _d === void 0 ? false : _d;
    if (!ldclient || !feature) {
        logger_1.logger.log('isFeatureInactive', 'client not initialized yet returning default');
        return defaultValue;
    }
    var showFeature = ldclient.variation(feature, defaultValue);
    logger_1.logger.log('isFeatureActive', "checking feature ".concat(feature, " ").concat(functionName ? 'in ' + functionName : ''));
    return showFeature !== activeValue;
};
exports.isFeatureInactive = isFeatureInactive;
//# sourceMappingURL=index.js.map